import React from 'react';
import * as Grid from './ImageGrid.styles';
import Picture from '../../styles/Picture';
import { IImageGrid } from './ImageGrid.types';

/**
 *
 * The Image Grid displays a collection of images, that are not interactive, in an organised grid. All
 * breakpoints have a minimum of **2** and maximum of **6** images/Illustrations.
 *
 * For logos we prefer SVGs. However, if bitmap images are needed, either JPGs or PNGs are recommended.
 */
export const ImageGrid: React.FC<IImageGrid> = ({ images }: IImageGrid) => {
  return (
    <div>
      <Grid.Wrapper>
        {images.map(({ source, alt }) => (
          <Grid.Item key={source as string}>
            <Picture source={source} alt={alt} />
          </Grid.Item>
        ))}
      </Grid.Wrapper>
    </div>
  );
};

ImageGrid.displayName = 'ImageGrid';
export default ImageGrid;
